import { render, staticRenderFns } from "./value-modal.vue?vue&type=template&id=1fd8d335&scoped=true&"
import script from "./value-modal.vue?vue&type=script&lang=js&"
export * from "./value-modal.vue?vue&type=script&lang=js&"
import style0 from "./value-modal.vue?vue&type=style&index=0&id=1fd8d335&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd8d335",
  null
  
)

export default component.exports